import { useRouterContext } from "@hooks";

export type HistoryType = "push" | "replace";

export const useNavigation = () => {
  const { useHistory } = useRouterContext();
  const history = useHistory();

  const handleUrl = (url: string, type: HistoryType = "push") => {
    if (type === "push") {
      history.push(url);
    } else {
      history.replace(url);
    }
  };

  const push = (path: string, state?: unknown) => {
    history.push(path, state);
  };

  const replace = (path: string, state?: unknown) => {
    history.replace(path, state);
  };

  const goBack = () => {
    history.goBack();
  };

  return {
    handleUrl,
    push,
    replace,
    goBack,
  };
};
